import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ContextMenuModel } from '../../models/context-menu-model';

import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'app-cell-context-menu',
  imports: [
    MatMenuModule
],
  templateUrl: './cell-context-menu.component.html',
  styleUrl: './cell-context-menu.component.scss'
})
export class CellContextMenuComponent implements AfterViewInit {
  @ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;

  @Input()
  contextMenuItems?: Array<ContextMenuModel>;

  @Output()
  onContextMenuItemClick: EventEmitter<{ event: Event, data: string }> = new EventEmitter<{ event: Event, data: string }>();

  onContextMenuClick(event: Event, data: string): any {
    this.onContextMenuItemClick.emit({
      event,
      data,
    });
  }

  ngAfterViewInit() {
    // Automatically open menu
    this.menuTrigger.openMenu();
  }
}